import styled from "styled-components";

export const SpeedUpButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0px;
  width: 48px;
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
  height: 48px;
  justify-content: center;
  position: relative;
  z-index: 1;

  &:hover {
    transform: scale(110%);
  }
`;
